import React, { useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const zoomButtons = document.querySelectorAll(
	'.block-fsa-content-bottom-image__zoom-btn'
);

zoomButtons.forEach((button) => {
	button.addEventListener('click', (e) => {
		e.preventDefault();

		e.currentTarget.previousElementSibling.click();
	});
});

const lightboxOpened = (e) => {
	if (!e?.detail?.lightboxComponent) {
		return;
	}

	const imageWrapper = document.querySelector(
		'.component-lightbox__frame .block-fsa-content-bottom-image__image-wrapper'
	);

	if (!imageWrapper) {
		return;
	}

	const frame = imageWrapper.closest('.component-lightbox__frame');
	const image = imageWrapper.querySelector(
		'.block-fsa-content-bottom-image__image'
	);

	if (!image || !frame) {
		return;
	}

	frame.classList.add('block-fsa-content-bottom-image__lightbox');

	const root = createRoot(imageWrapper);

	const ImageComponent = ({
		initialPositionX,
		initialPositionY,
		initialScale,
	}) => {
		const wrapperRef = useRef();

		return (
			<TransformWrapper
				initialScale={initialScale}
				initialPositionX={initialPositionX}
				initialPositionY={initialPositionY}
				doubleClick={{ mode: 'toggle' }}
				ref={wrapperRef}
			>
				<TransformComponent>
					<img
						src={image.getAttribute('src')}
						alt={image.getAttribute('alt') || ''}
					/>
				</TransformComponent>
			</TransformWrapper>
		);
	};

	let scale = image.getAttribute('height') / image.offsetHeight;
	const windowScale = (window.innerHeight - 110) / image.offsetHeight;

	if (scale > windowScale) {
		scale = windowScale;
	}

	let positionX;
	let positionY;

	if (e?.detail?.event?.offsetX && e?.detail?.event?.offsetY) {
		positionX = -e.detail.event.offsetX * scale + window.innerWidth / scale;
		positionY =
			-e.detail.event.offsetY * scale +
			(window.innerHeight - 110) / scale;
	} else {
		positionX = window.innerWidth / 2 - (image.offsetWidth * scale) / 2;
		positionY =
			(window.innerHeight - 110) / 2 - (image.offsetHeight * scale) / 2;
	}

	root.render(
		<ImageComponent
			initialPositionX={positionX}
			initialPositionY={positionY}
			initialScale={scale}
		/>
	);

	image.remove();
};

window.addEventListener('propel-lightbox-opened', lightboxOpened);
